import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';

/**
 * @figma
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=21842-60347&m=dev
 */
export class QuantityLimitedTag extends ProductTagBase<number> {
  protected makeLabel(): string | undefined {
    if (this.data.lang === 'kr') {
      if (this.data.value >= 100_000_000) {
        const value = Math.floor(this.data.value / 100_000_000);
        return `${value}억 개 남았어요!`;
      } else if (this.data.value >= 10_000) {
        const value = Math.floor(this.data.value / 10_000);
        return `${value}만 개 남았어요!`;
      } else if (this.data.value >= 1_000) {
        const value = Math.floor(this.data.value / 1_000);
        return `${value}천 개 남았어요!`;
      } else {
        return `${this.data.value}개 남았어요!`;
      }
    } else if (this.data.lang === 'jp') {
      if (this.data.value >= 100_000_000) {
        const value = Math.floor(this.data.value / 100_000_000);
        return `残り${value}億個`;
      } else if (this.data.value >= 10_000) {
        const value = Math.floor(this.data.value / 10_000);
        return `残り${value}万個`;
      } else if (this.data.value >= 1_000) {
        const value = Math.floor(this.data.value / 1_000);
        return `残り${value}千個`;
      } else {
        return `残り${this.data.value}個`;
      }
    } else if (this.data.lang === 'en') {
      if (this.data.value >= 1_000_000_000) {
        const value = Math.floor(this.data.value / 1_000_000_000);
        return `${value}B Left`;
      } else if (this.data.value >= 1_000_000) {
        const value = Math.floor(this.data.value / 1_000_000);
        return `${value}M Left`;
      } else if (this.data.value >= 1_000) {
        const value = Math.floor(this.data.value / 1_000);
        return `${value}K Left`;
      } else {
        return `${this.data.value} Left`;
      }
    }
    throw new Error(`Unknown lang: ${this.data.lang}`);
  }

  protected styles(): string {
    return klass.limited;
  }

  isTimerNeeded(): boolean {
    return false;
  }
}
